import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./components/Navbar";
import { goLogin, getPermission, getStampTime } from "./js/main";
import DescriptionIcon from "@material-ui/icons/Description";
import Conf from "./Conf";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import DownloadExcel from "./components/DownloadExcel";

const current_path = Conf.frontendURL + "recept";
const page_title = "รายงานใบเสร็จ";
const cookie = JSON.parse(localStorage.getItem(Conf.cookieName));
export default function Recept(props) {
  const [profile, setProfile] = useState(null);
  const [filter, setFilter] = useState(null);
  const [bills, setBills] = useState(null);
  const [report, setReport] = useState(null);
  const [excelState, setExcelState] = useState({});
  // const [facet, setFacet] = useState(null);
  // const [selectOperators, setSelectOperators] = useState([]);

  useEffect(() => {
    async function getAuth() {
      if (cookie && cookie.token) {
        var auth = await getPermission(cookie.token);
        if (auth === false) goLogin(current_path);
        else {
          let stamp_date = await getStampTime();
          stamp_date = stamp_date.iso_date;
          setProfile(auth.profile);
          setFilter({
            start_date: stamp_date,
            end_date: stamp_date,
            is_cash: true,
            is_tranfer: true,
            skip: 0,
            limit: 10000,
            sort: "bill_id",
          });
        }
      } else goLogin(current_path);
    }
    if (!profile) getAuth();
  }, [profile]);
  useEffect(() => {
    async function getResult() {
      let end_date = filter.end_date;
      let arr = end_date.split("-");
      arr[2] = ("0" + (parseInt(arr[2]) + 1)).slice(-2);
      end_date = arr[0] + "-" + arr[1] + "-" + arr[2];
      let query = {
        $and: [
          { transactionDateandTime: { $gte: filter.start_date } },
          { transactionDateandTime: { $lte: end_date } },
        ],
      };
      if (filter.is_tranfer === false) {
        query["$and"].push({
          transactionType: { $ne: "Domestic Transfers" },
        });
      }
      if (filter.is_cash === false) {
        query["$and"].push({
          transactionType: { $ne: "Pay by Cash" },
        });
      }

      query = JSON.stringify(query);
      let result = await axios.post(
        Conf.digitalpayBackend + "bill",
        {
          query: query,
          limit: filter.limit,
          skip: filter.skip,
          sort: filter.sort,
          facet: true,
        },
        {
          headers: { Authorization: cookie.token },
        }
      );
      for (var i = 0; i < result.data.facet.operator.length; i++) {
        result.data.facet.operator[i].checked = false;
      }
      setBills(result.data);
    }
    if (filter) getResult();
  }, [filter]);

  useEffect(() => {
    function getReport() {
      let Report = JSON.parse(JSON.stringify(bills));

      let operator = Report.facet.operator
        .filter((j) => j.checked === true)
        .map((j) => j.usn);
      if (operator.length > 0) {
        Report.bills = Report.bills.filter((j) => j.operator);
        Report.bills = Report.bills.filter(
          (j) => operator.indexOf(j.operator.usn) > -1
        );
      }
      Report.facet.total_amount = 0;
      Report.facet.total_cancel = 0;
      Report.facet.total_cash = 0;
      Report.facet.total_tranfer = 0;
      Report.facet.account = [];

      for (let bill of Report.bills) {
        let amount = parseFloat(bill.amount);
        Report.facet.total_amount += amount;
        if (bill.transactionType === "Pay by Cash")
          Report.facet.total_cash += amount;
        else Report.facet.total_tranfer += amount;
        if (bill.canceled.status === true) Report.facet.total_cancel++;
        else {
          for (let detail of bill.invoice_id.details) {
            let i = Report.facet.account.findIndex(
              (j) => j.account_code === detail.account_code
            );
            if (i < 0) {
              Report.facet.account.push({
                account_code: detail.account_code,
                amount: parseFloat(detail.amount),
                biller_name: detail.biller_name,
              });
            } else {
              Report.facet.account[i].amount += parseFloat(detail.amount);
            }
          }
        }
      }
      setReport(Report);
    }
    if (bills) getReport();
  }, [bills]);

  function selOperator(e) {
    let Bills = JSON.parse(JSON.stringify(bills));
    let i = Bills.facet.operator.findIndex((j) => j.usn === e.target.value);
    Bills.facet.operator[i].checked = e.target.checked;
    setBills({ ...bills, facet: Bills.facet });
    // props.onSelectOperators(Operators);
    // console.log(Operators.filter((j) => j.checked === true));
  }
  // function billTableFilter() {
  //   let Bills = JSON.parse(JSON.stringify(bills));
  //   let operator = Bills.facet.operator
  //     .filter((j) => j.checked === true)
  //     .map((j) => j.usn);
  //   if (operator.length > 0) {
  //     Bills.bills = Bills.bills.filter((j) => j.operator);
  //     Bills.bills = Bills.bills.filter(
  //       (j) => operator.indexOf(j.operator.usn) > -1
  //     );
  //   }
  //   return Bills;
  // }

  function getSheet() {
    return new Promise(async (resolve) => {
      let sheet = [];
      let no = 1;
      for (let bill of report.bills) {
        let details_stream = "";
        for (let detail of bill.invoice_id.details) {
          if (details_stream !== "") details_stream += ", ";
          details_stream += detail.biller_name;
        }
        sheet.push({
          no: no++,
          invoice_id: bill.invoice_id.invoice_id,
          bill_date: bill.bill_date,
          bill_id: bill.bill_id,
          payerName: bill.payer.name,
          amount: bill.amount,
          details_stream,
          transactionType:
            bill.transactionType === "Pay by Cash" ? "CASH" : "TRANFER",
          operator_usn: bill.operator.usn,
          canceled_remark: bill.canceled.remark,
          canceled_new_bill_no: bill.canceled.new_bill_no,
          replace_bill_no: bill.replace_bill_no,
        });
      }
      resolve(sheet);
    });
  }
  async function downloadExcel() {
    let sheet = await getSheet();
    let dataSet = {
      columns: [
        {
          label: "วันที่ออก Invoice",
          value: "no",
        },
        {
          label: "Invoice No",
          value: "invoice_id",
        },
        {
          label: "วันที่ออกใบเสร็จ",
          value: "bill_date",
        },
        {
          label: "เลขที่ใบเสร็จ",
          value: "bill_id",
        },
        {
          label: "ชื่อ-สกุล",
          value: "payerName",
        },
        {
          label: "จำนวนเงิน",
          value: "amount",
        },
        {
          label: "ประเภทรายได้",
          value: "details_stream",
        },
        {
          label: "การรับเงิน",
          value: "transactionType",
        },
        {
          label: "ผู้ดำเนินการ",
          value: "operator_usn",
        },
        {
          label: "ยกเลิกใบเสร็จ",
          value: "canceled_status",
        },
        {
          label: "ออกใบเสร็จใหม่",
          value: "canceled_new_bill_no",
        },
        {
          label: "ใบเสร็จที่ออกแทน",
          value: "replace_bill_no",
        },
        {
          label: "หมายเหตุ",
          value: "canceled_remark",
        },
      ],
      sheet,
    };

    console.log(dataSet);
    setExcelState({ dataSet, on_download: true });
    setTimeout(() => {
      setExcelState({ ...excelState, on_download: false });
    }, 1000);
  }
  return (
    <div>
      {profile && (
        <>
          <Navbar />
          <main className="content">
            <h1 className="pageTitle">
              <div
                style={{
                  float: "left",
                  paddingTop: "5px",
                  marginRight: "15px",
                }}
              >
                <DescriptionIcon style={{ fontSize: "2rem" }} />
              </div>
              <div style={{ float: "none" }}>{page_title}</div>
            </h1>
            {excelState.on_download === true && (
              <>
                <DownloadExcel dataSet={excelState.dataSet} />
              </>
            )}
            {filter && bills && (
              <FilterForm
                filter={filter}
                facet={bills.facet || null}
                onChangeFilter={(id, value) =>
                  setFilter({ ...filter, [id]: value })
                }
                onSelectOperators={(e) => selOperator(e)}
              />
            )}
            {bills && report && (
              <>
                {/* <BillTable bills={billTableFilter} /> */}
                <BillTable bills={report} />
                <br />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                    <FacetAmountTable facet={report.facet} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <FacetAccountTable facet={report.facet} />
                  </Grid>
                </Grid>
              </>
            )}
            <br />

            <Button
              variant="contained"
              color="primary"
              onClick={() => downloadExcel()}
            >
              Export with Excel
            </Button>
          </main>
        </>
      )}
    </div>
  );
}

function FacetAccountTable(props) {
  const { facet } = props;
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="td" align="center" colSpan={3}>
                ประเภทรายได้
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {facet.account.map((acc, key) => (
              <TableRow key={key} hover>
                <TableCell className="td">
                  <span style={{ margin: "auto 15px auto 10px" }}>
                    ({acc.account_code})
                  </span>
                  {acc.biller_name}
                </TableCell>
                <TableCell className="td" align="right">
                  {acc.amount.toLocaleString()}
                </TableCell>
                <TableCell className="td">บาท</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function FacetAmountTable(props) {
  const { facet } = props;
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="td" align="center" colSpan={3}>
                ยอดเงิน
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell className="td" align="right">
                รวมเป็นเงิน
              </TableCell>
              <TableCell className="td" align="right">
                {facet.total_amount.toLocaleString()}
              </TableCell>
              <TableCell className="td">บาท</TableCell>
            </TableRow>
            {facet.total_cash > 0 && (
              <TableRow hover>
                <TableCell className="td" align="right">
                  เงินสด
                </TableCell>
                <TableCell className="td" align="right">
                  {facet.total_cash.toLocaleString()}
                </TableCell>
                <TableCell className="td">บาท</TableCell>
              </TableRow>
            )}

            {facet.total_tranfer > 0 && (
              <TableRow hover>
                <TableCell className="td" align="right">
                  เงินโอน
                </TableCell>
                <TableCell className="td" align="right">
                  {facet.total_tranfer.toLocaleString()}
                </TableCell>
                <TableCell className="td">บาท</TableCell>
              </TableRow>
            )}
            {facet.total_cancel > 0 && (
              <TableRow hover>
                <TableCell className="td" align="right">
                  รายการยกเลิก
                </TableCell>
                <TableCell className="td" align="right">
                  {facet.total_cancel.toLocaleString()}
                </TableCell>
                <TableCell className="td">รายการ</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function BillTable(props) {
  const { bills } = props;
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="smallTd">วันที่ออกInvoice</TableCell>
              <TableCell className="smallTd">Invoice No</TableCell>
              <TableCell className="smallTd">วันที่ออกใบเสร็จ</TableCell>
              <TableCell className="smallTd">เลขที่ใบเสร็จ</TableCell>
              <TableCell className="smallTd">ชื่อ-สกุล</TableCell>
              <TableCell className="smallTd">จำนวนเงิน</TableCell>
              <TableCell className="smallTd">ประเภทรายได้</TableCell>
              <TableCell className="smallTd">การรับเงิน</TableCell>
              <TableCell className="smallTd">Transaction</TableCell>
              <TableCell className="smallTd">Ref2</TableCell>
              <TableCell className="smallTd">ผู้ดำเนินการ</TableCell>
              <TableCell className="smallTd">ยกเลิกใบเสร็จ</TableCell>
              <TableCell className="smallTd">ออกใบเสร็จใหม่</TableCell>
              <TableCell className="smallTd">ใบเสร็จที่ออกแทน</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bills.bills.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={14}
                  align="center"
                  style={{ color: "#666" }}
                >
                  ไม่พบข้อมูล
                </TableCell>
              </TableRow>
            )}
            {bills.bills.map((bill, key) => (
              <TableRow
                key={key}
                hover
                style={
                  bill.canceled.status === true ? { background: "#ffe5e5" } : {}
                }
              >
                <TableCell className="smallTd" align="center">
                  {bill.invoice_id.create_date}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.invoice_id.invoice_id}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.invoice_id.create_date}
                </TableCell>
                <TableCell align="center" style={{ padding: "1px 0px" }}>
                  <Button
                    to={process.env.PUBLIC_URL + "/bill/" + bill.bill_id}
                    component={Link}
                    style={{ padding: "0px 0px", color: "#00f" }}
                  >
                    <div className="smallTd">{bill.bill_id}</div>
                  </Button>
                </TableCell>
                <TableCell className="smallTd">
                  {bill.invoice_id.debtor_name}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.amount}
                </TableCell>
                <TableCell className="smallTd">
                  {bill.invoice_id.details.map((detail) => (
                    <div key={detail._id}>{detail.biller_name}</div>
                  ))}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.transactionType === "Pay by Cash" ? "CASH" : "TRANFER"}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.transactionId}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.billPaymentRef2}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.operator && bill.operator.usn}
                </TableCell>
                <TableCell className="smallTd" align="center">
                  {bill.canceled && bill.canceled.remark}
                </TableCell>
                <TableCell align="center" style={{ padding: "1px 0px" }}>
                  <Button
                    to={
                      process.env.PUBLIC_URL +
                      "/bill/" +
                      bill.canceled.new_bill_no
                    }
                    component={Link}
                    style={{ padding: "0px 0px", color: "#00f" }}
                  >
                    <div className="smallTd">{bill.canceled.new_bill_no}</div>
                  </Button>
                </TableCell>
                <TableCell align="center" style={{ padding: "1px 0px" }}>
                  <Button
                    to={
                      process.env.PUBLIC_URL + "/bill/" + bill.replace_bill_no
                    }
                    component={Link}
                    style={{ padding: "0px 0px", color: "#00f" }}
                  >
                    <div className="smallTd">{bill.replace_bill_no}</div>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

const FilterForm = (props) => {
  const { filter, onChangeFilter, facet } = props;
  // const [operators, setOperators] = useState([]);
  useEffect(() => {
    if (props.facet.operator && props.facet.operator.length > 0) {
      let operators = props.facet.operator;
      for (let opr of operators) {
        if (!opr.checked) opr.checked = false;
      }
      // setOperators(operators);
    }
  }, [props]);
  function changeDate(date, date2, id) {
    onChangeFilter(id, date2);
  }
  function selectUSN(e) {
    props.onSelectOperators(e);
    /*
    let Operators = JSON.parse(JSON.stringify(operators));
    let i = Operators.findIndex((j) => j.usn === e.target.value);
    Operators[i].checked = e.target.checked;
    setOperators(Operators);
    props.onSelectOperators(Operators);
    console.log(Operators.filter((j) => j.checked === true));
    */
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={9} lg={10}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container spacing={1}>
              <Grid item>
                <KeyboardDatePicker
                  margin="normal"
                  autoOk
                  id="start_date"
                  label="From Date"
                  format="yyyy-MM-dd"
                  value={filter.start_date}
                  onChange={(date, date2) =>
                    changeDate(date, date2, "start_date")
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  inputVariant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item>
                <KeyboardDatePicker
                  margin="normal"
                  autoOk
                  id="end_date"
                  label="to Date"
                  format="yyyy-MM-dd"
                  value={filter.end_date}
                  onChange={(date, date2) =>
                    changeDate(date, date2, "end_date")
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  inputVariant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={2} align="right">
          <div style={{ width: "120px", textAlign: "left" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filter.is_cash}
                  onChange={() => onChangeFilter("is_cash", !filter.is_cash)}
                  name="checkedB"
                  color="primary"
                />
              }
              label="CASH"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filter.is_tranfer}
                  onChange={() =>
                    onChangeFilter("is_tranfer", !filter.is_tranfer)
                  }
                  name="checkedB"
                  color="primary"
                />
              }
              label="TRANFER"
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          {facet.operator.map((opr) => (
            <FormControlLabel
              key={opr.usn}
              control={
                <Checkbox
                  checked={opr.checked}
                  onChange={selectUSN}
                  name="usn"
                  value={opr.usn}
                />
              }
              label={opr.usn}
            />
          ))}
        </Grid>
      </Grid>
    </div>
  );
};
